import React, { useEffect, useState } from "react";

export interface InlineTextInputCellValue {
  value: string;
  placeholder?: string;
  ariaLabel?: string;
  disabled?: boolean;
  /** Optional pattern for client-side validation; when invalid the input shows a red border but still emits. */
  pattern?: RegExp;
}

interface InlineTextInputCellProps {
  value: InlineTextInputCellValue;
  rowData?: any;
  header?: string;
  onCellValueChange?: (rowData: any, fieldKey: string, newValue: any) => void;
}

const InlineTextInputCell: React.FC<InlineTextInputCellProps> = ({
  value,
  rowData,
  header,
  onCellValueChange,
}) => {
  const [local, setLocal] = useState(value.value || "");

  // Keep local in sync if the row's underlying value changes externally.
  useEffect(() => {
    setLocal(value.value || "");
  }, [value.value]);

  const invalid = value.pattern
    ? !value.pattern.test(local) && local !== ""
    : false;

  const commit = (next: string) => {
    if (next !== (value.value || "") && onCellValueChange) {
      onCellValueChange(rowData, header || "", next);
    }
  };

  return (
    <input
      aria-label={value.ariaLabel || `Edit ${header || "value"}`}
      value={local}
      placeholder={value.placeholder || "—"}
      disabled={value.disabled}
      onClick={(e) => e.stopPropagation()}
      onChange={(e) => setLocal(e.target.value)}
      onBlur={(e) => commit(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === "Enter") (e.target as HTMLInputElement).blur();
      }}
      className={`w-full rounded-md border px-2 py-1 text-x-tiny text-primaryGray-1 outline-none focus:border-tertiaryBlue-4 ${
        invalid ? "border-tertiaryRed-4" : "border-primaryGray-14"
      } ${value.disabled ? "cursor-not-allowed bg-primaryGray-16" : ""}`}
    />
  );
};

export default InlineTextInputCell;
